var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("breadcrumb", { attrs: { breadcrumbConfig: _vm.breadcrumbConfig } }),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h2", [_vm._v("物流订单")]),
          _c("h3", [_vm._v("数据筛选")]),
          _c("form-filed", {
            ref: "formAttr",
            staticClass: "search-form",
            attrs: {
              formconfig: _vm.searchFormConfig.formconfig,
              formData: _vm.searchFormConfig.formData,
            },
            on: {
              cascaderValue: _vm.handlerCascaderValue,
              formDataval: _vm.dialogClick,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h3", [_vm._v("列表数据")]),
          _c("div", { staticClass: "but-list" }, [
            _c(
              "div",
              { staticClass: "left" },
              _vm._l(_vm.logisticsStatus, function (val, key) {
                return _c(
                  "el-button",
                  {
                    key: key,
                    attrs: {
                      disabled: _vm.loading,
                      type:
                        _vm.currentStatus === val.values ? "primary" : "info",
                      size: "small",
                      plain: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onChangeLogisticsStatus(val.values)
                      },
                    },
                  },
                  [_vm._v(_vm._s(val.title) + "(" + _vm._s(val.total) + ") ")]
                )
              }),
              1
            ),
            _c(
              "div",
              { staticClass: "right" },
              [
                _vm.currentStatus === ""
                  ? _c(
                      "el-button",
                      {
                        staticClass: "stay-deliver-goods-but",
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.importLogisticsOrder1 },
                      },
                      [_vm._v("导出 ")]
                    )
                  : _vm._e(),
                _vm.currentStatus === 2
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.onStockUp(true)
                          },
                        },
                      },
                      [_vm._v("批量备货 ")]
                    )
                  : _vm._e(),
                _vm.currentStatus === 3
                  ? _c(
                      "el-button",
                      {
                        staticClass: "stock-up-send-but",
                        attrs: {
                          type: "primary",
                          size: "small",
                          loading: _vm.btnLoading,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.deriveDeliverGoods()
                          },
                        },
                      },
                      [_vm._v("导出发货 ")]
                    )
                  : _vm._e(),
                _vm.currentStatus === 3
                  ? _c(
                      "el-button",
                      {
                        staticClass: "stock-up-record-but",
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.onApplierExport()
                          },
                        },
                      },
                      [_vm._v("导出记录 ")]
                    )
                  : _vm._e(),
                _vm.currentStatus === 4
                  ? _c(
                      "el-button",
                      {
                        staticClass: "stay-deliver-goods-but",
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.importLogisticsOrder },
                      },
                      [_vm._v("导出 ")]
                    )
                  : _vm._e(),
                _vm.currentStatus === 4
                  ? _c(
                      "el-button",
                      {
                        staticClass: "stay-deliver-goods-but",
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.leadingIn(0)
                          },
                        },
                      },
                      [_vm._v("导入物流单 ")]
                    )
                  : _vm._e(),
                _vm.currentStatus === 5
                  ? _c(
                      "el-button",
                      {
                        staticClass: "stay-deliver-goods-but",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.leadingIn(1)
                          },
                        },
                      },
                      [_vm._v("批量修改物流单号 ")]
                    )
                  : _vm._e(),
                _vm.currentStatus === 5
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          size: "small",
                          type: "primary",
                          loading: _vm.btnLoading,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.importLogisticsData(5)
                          },
                        },
                      },
                      [_vm._v("导出物流数据 ")]
                    )
                  : _vm._e(),
                _vm.currentStatus === 6
                  ? _c(
                      "el-button",
                      {
                        staticClass: "stay-deliver-goods-but",
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.importLogisticsData(6)
                          },
                        },
                      },
                      [_vm._v("导出物流数据 ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c("orders-list-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              dataList: _vm.page.list,
              heightStr: _vm.columns.height,
              config: _vm.columns.config,
              typeStr: _vm.columns.type,
            },
            on: {
              optionDialog: _vm.optionDialog,
              lookDialog: _vm.lookDialog,
              tableSelectionChange: _vm.tableSelectionChange,
            },
          }),
          _c(
            "div",
            {
              staticClass: "page",
              staticStyle: {
                float: "right",
                margin: "10px 10px",
                "padding-bottom": "10px",
              },
            },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.page.currentPage,
                  "page-sizes": [3, 5, 10, 20, 50],
                  "page-size": _vm.page.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.page.totalNum,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.page, "currentPage", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.page, "currentPage", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            "append-to-body": "",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "el-form",
                {
                  ref: "dialogForm",
                  attrs: {
                    model: _vm.dialogForm,
                    "label-width": "80px",
                    rules: _vm.rules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "物流公司", prop: "logisticsCompany" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择物流公司",
                            filterable: "",
                          },
                          model: {
                            value: _vm.dialogForm.logisticsCompany,
                            callback: function ($$v) {
                              _vm.$set(_vm.dialogForm, "logisticsCompany", $$v)
                            },
                            expression: "dialogForm.logisticsCompany",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.courier_company,
                          function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "物流单号", prop: "logisticsNumber" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入物流单号" },
                        model: {
                          value: _vm.dialogForm.logisticsNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialogForm, "logisticsNumber", $$v)
                          },
                          expression: "dialogForm.logisticsNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "20px", "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "20px" },
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "物流信息",
            visible: _vm.dialogLook,
            "append-to-body": "",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogLook = $event
            },
          },
        },
        [
          _c("StepLogistics", {
            attrs: { stepProgress: _vm.logisticsMessage },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "导出记录",
            visible: _vm.dialogRecord,
            "append-to-body": "",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogRecord = $event
            },
          },
        },
        [
          _c("lb-table", {
            attrs: {
              column: _vm.columnsDeriveRecord,
              data: _vm.deriveRecordList.list,
              pagination: "",
              total: _vm.deriveRecordList.totalNum,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [5, 10, 20, 30, 50],
              "current-page": _vm.page.currentPage,
              "page-size": _vm.page.pageSize,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "size-change": _vm.handleSizeChangeDeriveRecord,
              "p-current-change": _vm.handleCurrentChangeDeriveRecord,
            },
          }),
          _c(
            "div",
            { staticStyle: { "margin-top": "20px", "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "20px" },
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialogRecord = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogRecord = false
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.inTitle,
            visible: _vm.dialogIn,
            "append-to-body": "",
            width: "640px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogIn = $event
            },
          },
        },
        [
          [
            _c(
              "div",
              [
                _c(
                  "el-upload",
                  {
                    ref: "tops",
                    staticClass: "upload-demo",
                    staticStyle: { width: "100%" },
                    attrs: {
                      accept: ".doc,.docx,.xls,.xlsx,.csv",
                      drag: "",
                      action: "#",
                      multiple: false,
                      "http-request": _vm.orderImport,
                      limit: 1,
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-upload" }),
                    _c("div", { staticClass: "el-upload__text" }, [
                      _vm._v(" 将文件拖到此处，或"),
                      _c("em", [_vm._v("点击上传")]),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "20px",
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _c(
                "div",
                { on: { click: _vm.downloadTemplate } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "text", icon: "el-icon-download" } },
                    [_vm._v("导入模板下载")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "20px" },
                      attrs: { plain: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogIn = false
                          _vm.$refs["tops"].clearFiles()
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.submitIn()
                          _vm.$refs["tops"].clearFiles()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }